var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "crp", class: { "crp--disabled": _vm.disabled } },
    [
      _c("i", { staticClass: "far fa-calendar-alt crp__icon" }),
      _c("date-picker", {
        staticClass: "w-100",
        attrs: {
          "append-to-body": false,
          clearable: false,
          disabled: _vm.disabled,
          editable: false,
          format: _vm.format,
          lang: _vm.lang,
          placeholder: _vm.placeholder,
          range: "",
          "show-time-panel": false,
          value: _vm.value,
          "value-type": "date"
        },
        on: { input: _vm.onInput }
      }),
      _vm.clearable && _vm.hasValue && !_vm.disabled
        ? _c(
            "button",
            {
              staticClass: "crp__clear",
              attrs: { type: "button" },
              on: { click: _vm.clear }
            },
            [_vm._v(" × ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }